const CHANNEL = 'epik-device-swap';
const STORAGE_KEY = 'epik-device-swap-status';

export function publishDeviceSwapStatus(payload) {
  if (!payload) return;
  try {
    const serialized = JSON.stringify(payload);
    localStorage.setItem(STORAGE_KEY, serialized);
    if (typeof BroadcastChannel !== 'undefined') {
      const channel = new BroadcastChannel(CHANNEL);
      channel.postMessage(payload);
      channel.close();
    }
  } catch (err) {
    // ignore storage/channel failures
  }
}

export function subscribeDeviceSwapStatus(handler) {
  if (typeof handler !== 'function') return () => {};

  const onMessage = event => {
    if (event && event.data) handler(event.data);
  };
  const onStorage = event => {
    if (event.key !== STORAGE_KEY || !event.newValue) return;
    try {
      handler(JSON.parse(event.newValue));
    } catch (err) {
      // ignore malformed payloads
    }
  };

  window.addEventListener('storage', onStorage);
  let channel;
  if (typeof BroadcastChannel !== 'undefined') {
    channel = new BroadcastChannel(CHANNEL);
    channel.onmessage = onMessage;
  }

  return () => {
    window.removeEventListener('storage', onStorage);
    if (channel) channel.close();
  };
}
